import React, { useState, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllMoshtariTblData } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import CustomerTable from "./components/CustomerTable";
import AddCustomer from "./components/AddCustomer/AddCustomer";
import ManageCustomerGroup from "./components/ManageCustomerGroup/ManageCustomerGroup";
import Translator from "Languages/Utility/Translator";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function Customers() {
  const { customerDataPagination } = useSelector((state) => ({
    customerDataPagination: state.customer.customerDataPagination,
  }));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: customerDataPagination.Limit,
          Page: customerDataPagination.Page,
          Name: "",
        };
        await dispatch(getAllMoshtariTblData(params));
        setLoading(false);
      } catch (err) {
      console.error('[catch error]', err)
    }
    })();
  }, []);

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id="moshtari" />} />
        <div className="top-buttons">
          {read("groupCustomerRules") !== null &&
            read("groupCustomerRules")?.accessShow !== false && (
              <ManageCustomerGroup />
            )}
          <AddCustomer />
        </div>
      </div>
      <MuiPaper className="mb-5">
        <CustomerTable />
      </MuiPaper>
    </Fragment>
  );
}

export default Customers;
